/**
 * Eyebrow — small uppercase label that sits above section titles.
 */
export default function Eyebrow({ children, tone = 'ink' }) {
  return (
    <div
      style={{
        fontFamily: 'var(--font-body)',
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: tone === 'ink' ? 'var(--ink-3)' : 'var(--blue)',
      }}
    >
      {children}
    </div>
  );
}
